export { validateEmail } from '../EmailLogin/validation';

/**
 * 새 비밀번호 규칙 (영문·숫자·특수문자 모두 포함, 8~16자).
 */
const NEW_PASSWORD_REGEX =
  /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!"#$%&'()*+,\-./:;<=>?@[₩\]^_`{|}~])[A-Za-z0-9!"#$%&'()*+,\-./:;<=>?@[₩\]^_`{|}~]{8,16}$/;

export const validateNewPassword = (value: string): string | undefined => {
  if (value.length === 0) {
    return '비밀번호를 입력해주세요';
  }
  if (!NEW_PASSWORD_REGEX.test(value)) {
    return '영문, 숫자, 특수문자 8~16자를 입력해주세요';
  }
  return undefined;
};
